import * as RadixDialog from '@radix-ui/react-dialog';
import { forwardRef, ReactNode } from 'react';

type DialogTitleProps = Omit<
  RadixDialog.DialogTitleProps,
  'asChild' | 'children' | 'id'
> & {
  children: ReactNode;
};

const DialogTitle = forwardRef<HTMLHeadingElement, DialogTitleProps>(
  ({ children, className, ...props }, ref) => (
    <RadixDialog.Title className={className} ref={ref} {...props}>
      {children}
    </RadixDialog.Title>
  ),
);
DialogTitle.displayName = 'DialogTitle';

export { DialogTitle, type DialogTitleProps };
